import React, { useState,useRef, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import { Button, Modal, Card, IconButton,CardHeader, CardContent, Divider,InputAdornment,FormControl,OutlinedInput,MenuItem,Checkbox,Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Box from '@mui/material/Box';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import Switch from '@common/Switch';
import { useTheme } from '@mui/styles';
import EditIcon from '@mui/icons-material/Edit';
import logo from "@assets/images/logo.png";
import Lottie from "lottie-react";
import loadAnim from "@assets/sandLoading.json";
import { toast } from '@utils/Events/constants';
import StyledPagination from '@components/common/StyledPagination';

const uncheckedIcon = <CheckBoxOutlineBlankIcon sx={{ color: '#838181' }} fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" sx={{ color: 'rgb(19, 107, 214)' }} />;
const SORT_OPTIONS = [
	{ label: 'Most recent', value: 'created_at_desc' },
	{ label: 'Least recent', value: 'created_at_asc' },
	{ label: 'Name (A-Z)', value: 'name_asc' },
	{ label: 'Name (Z-A)', value: 'name_desc' }
];
const SX = {
	menuItem:(theme)=>({
		color: theme.palette.text.black,
		fontFamily:theme.typography.fontFamily.primary,
		fontSize: 14,
		fontWeight:600,
		lineHeight: '24px'
	}),
	fCenter:{
		display:'flex',
		justifyContent:'center',
		alignItems:'center'
	},
	container:{
		display:'flex',
		justifyContent:'center',
		alignItems:'center',
		flexDirection:'column',
		height:'100vh'
	},
    card:(theme)=> {
        return ({
		//maxWidth: 550,
		textAlign: "center",
		fontFamily:theme.typography.fontFamily.primary,
		"&.mw-600":{
			minWidth:600
		},
		"&.mw-500":{
			minWidth:500
		},
		"&.mw-400":{
			minWidth:400
		},
		"& img":{
			maxHeight:80,
		},
		"& .no-wrap":{
			whiteSpace:'nowrap',
		},
		"& .d-flex":{
			display:'flex',
			
			"&.flex-ac":{
				alignItems:'center'
			},
		},
		"& h2": {
		  padding: 0,
		  color: theme.palette.text.black,
		  fontSize: 24,
		  fontWeight: 600,
		  letterSpacing: 0.32,
		  lineHeight: "32px",
		},
		"& .close":{
			float:'right',
			cursor:'pointer'
		},
		'& .MuiCardHeader-title':{
			'& img':{
				maxHeight:60
			},
			'& h2':{
				fontSize:20,
				lineHeight:'24px'
			}
		},
		"& p.MuiTypography-root": {
		  paddingTop: '5px',
		  color: theme.palette.text.black,
		  fontFamily:theme.typography.fontFamily.primary,
		  fontSize: 16,
		  fontWeight: 600,
		  letterSpacing: 0.25,
		  lineHeight: "20px",
		  marginBottom:'16px'
		},
        '& .required':{
            color:'red',
            fontSize:24,
            fontWeight:600
        },
		'& .m-8':{
			margin:'8px'
		},
		'& .pb-0':{
			paddingBottom:0
		},
		'& .link':{
			color:'var(--sm_primary)',
			textDecoration:'underline',
			cursor:'pointer'
		},
		'& .note-sugst':{
			'& span':{
				fontWeight:600,
			},
			'& button':{
				margin:'0 4px 4px 0',
				textTransform:'none'
			}
		},
		'& .MuiAutocomplete-root':{
			maxWidth:500
		},
		'& .MuiChip-root':{
			height:24
		},
		'& .MuiChip-label':{
			fontSize:10,
			maxWidth:200
		},
		'& .MuiChip-deleteIcon':{
			fontSize:16
		},
		'& .MuiAutocomplete-input':{
			padding:'4px !important'
		},
		'& .dropDown':{
			width: 300,
			cursor:"pointer",
			padding: '16px 4px',
			'&.MuiFormControl-fullWidth':{
				width:'100%'
			},
			"& label": {
			  padding:"10px",
			  //background: theme.palette.background.white,
			  color: theme.palette.text.inputLabel,
			  fontSize: "16px",
			  fontWeight: 600,
			  lineHeight: "24px",
			},
			'& .MuiInputBase-root': {
				height:35,
				background: theme.palette.background.white,
			},
			'& .MuiOutlinedInput-input':{ 
				padding: '16px 14px', 
				textAlign:'left',
				color: theme.palette.text.black,
				fontSize: "16px", 
				fontWeight: 600,
				fontFamily:theme.typography.fontFamily.primary,
			},
			'& .MuiInputLabel-outlined.MuiInputLabel-shrink':{ transform: 'translate(18px, -9px) scale(1)', fontSize:"12px", padding:"5px"},
			 '& fieldset':{ 
			  borderColor: theme.palette.border.primary,
			  '& legend': { fontSize: 12 }
			},
			'& .MuiSelect-select:focus':{
				backgroundColor: theme.palette.background.white
			},
			'& svg':{
				color: 'var(--sm_primary)',
				border: '1px solid var(--sm_primary)',
				borderRadius: '4px'
			},
			"&.small":{
				width:140,
				padding:'6px',
				'& .MuiOutlinedInput-input':{ 
					padding: '6px', 
				}
			},
			'&.sm':{
				width:90,
				padding:0,
				'& .MuiInputBase-root': {
					height:27
			   },
			   '& svg':{
				   right:'3px'
			   },
			   '& .MuiOutlinedInput-input':{ 
				 width:70,
				 padding:0,
			   },
			   '& fieldset':{ 
					border:'none'
			   }
			}
		},
		'& .clinic-list-ctr':{
			display:'flex',
			flexDirection:'column',
			gap:1,
			mb:1,
			width:1000,
			margin:'auto',
			pb:3,
			'&.multi-page-true':{
				height:290
			},
			'& .search-header':{
				display:'flex',
				justifyContent:'space-between',
				alignItems: 'center',
				width:'100%',
				mb:2,
				'& .searchCtr':{
					backgroundColor:'#fff',
					minWidth:'300px'
				},
				'& .MuiInputBase-root':{
					height:42
				},
				'& .MuiOutlinedInput-adornedEnd':{ paddingRight: 0, color: theme.palette.new.text.primary },
				'& .MuiOutlinedInput-input':{ color: theme.palette.new.text.primary},
				'& .MuiInputBase-input':{
					color:theme.palette.new.text.primary,
					fontFamily:theme.typography.new.fontFamily.primary,
					fontSize:14,
					fontWeight:500
				},
				'& .MuiDivider-root':{
					height: 28,
					margin: 4,
				},
				'& svg':{
					color: theme.typography.new.icon.color,
					cursor: "pointer",
					fontSize: "24px",
					'&.delete':{
						fontSize: "20px",
						//marginRight:'12px'
					}
				},
				'& .separator':{
					height: 22,
    				borderLeft: '1px solid #e3dede',
    				marginLeft: '6px',
    				marginRight: '-6px'
				},
				'& fieldset':{
					borderColor: 'var(--sm_primary)',
					borderRadius: '8px',
				},
				'& .MuiButtonBase-root:hover': {
					backgroundColor: 'unset'
				}
			},
			'& .pagination':{
				width:'100%',
				display:'flex',
				justifyContent:'flex-end'
			},
		},
		'& .clinic-list':{
			display:'flex',
			flexWrap:'wrap',
			gap:1,
			'& .clinic-item':{
				width:230,
				height:40,
				display:'flex',
				alignItems:'center',
				border:'1px solid #d3cece',
				borderRadius:1,
				gap:1,
				padding:'4px 8px',
				'& img':{
					maxHeight:32,
					objectFit:'scale-down',
					verticalAlign:'middle'
				},
				'& .name':{
					width:'calc(100% - 9px)',
					overflow:'hidden',
					textOverflow:'ellipsis',
					whiteSpace:'nowrap'
				},
				'&.selected':{
					borderColor:'blue'
				}
			}
		},
		'& .page-info':{
			display:'flex',
			alignItems:'center',
			gap:1,
			'& .sort-menu':{
				width:150,
				'& .MuiInputBase-root':{
					height:32,
				}
			}
		}
	})},
	loaderModal:{
		zIndex:1402,
		'& .MuiBackdrop-root':{
			backgroundColor:'rgb(0 0 0 / 5%)'
		}
	},
	loaderAnim:{
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 200,
		bgcolor: '#ffffffe0',
		borderRadius: '8px'
	},
    confirmModal:{
		//display: 'flex',
		//alignItems: 'center',
		//justifyContent: 'center',
		zIndex:1402,
		'& .p-info':{
			padding:'8px',
			backgroundColor:'#f9f9e4',
			fontSize:16,
			fontWeight:600,
			margin:'0 16px 12px',
			'& .info':{
				fontSize:14,
				fontWeight:500,

			}
		}
	},
    modalActions:(theme)=>({
		fontFamily:theme.typography.fontFamily.primary,
		padding: 1.5,
		//borderTop: '1px solid rgb(190 194 205 / .3)',
		//marginTop: '18px',
		display: 'flex',
		justifyContent: 'center',
		width:'100%',
		'& button.button':{
			margin:1,
            fontWeight: 600,
			fontSize:16,
            color:theme.palette.text.black,
            border: " 1px solid var(--sm_primary)",
			minWidth:140,
            textTransform:'none',
            '&.primary':{
                backgroundColor:'var(--sm_primary)',
                color:'white'
            },
            '&.Mui-disabled':{
                borderColor: theme.palette.border.primary,
                backgroundColor:'unset',
                color:'rgba(0, 0, 0, 0.26)',
                cursor:'not-allowed'
            }
		}
	})
}
const menuItemSx = {
	fontFamily:'sans-serif',
	fontSize:15,
	'& .menu-item-hover':{
		visibility:'hidden',
		margin:'0 8px',
		padding:0.5,
		border: '2px solid var(--sm_primary)',
		color: '#000',
		backgroundColor:'#fff',
	},
	'&:hover':{
		'& .menu-item-hover':{
			visibility:'visible',
			cursor:'pointer'
		}
	}
}
const Loader = ()=>{
	const [state,setState] = useState({show:false})
	const show = ()=>setState({show:true});
	const hide = ()=>setState({show:false});
	useEffect(()=>{
		const sub = _app.events.subscribe({'cust:loader:show':show,'cust:loader:hide':hide});
		return ()=>_app.events.unsubscribe(sub);
	},[])
	return state.show && <Modal open sx={SX.loaderModal} onClose={hide} className='custom-loader'>
		<Box sx={SX.loaderAnim} className="animation"><Lottie animationData={loadAnim} /></Box></Modal>
}
var ROLE_CACHE = {};
const ClinicSelector = ({ listApi,savedPref,rolesPermissions,rolesApi,currentRole,clinicListInfo,usePermissionByRole, onClinicSwitch,getActivePages,showClinicName,userPreferences }) => {
    useEffect(()=>{
		//console.log('CLINIC_SELECTION init',userPreferences,userClinics.length);
		userPreferences.clinicSelectionPending && clinicListInfo.total_items > 1 && openModal(null,{clinicSelectionPending:true});
	},[])
	const theme = useTheme();
    const selectedClinic = useRef(null);
    clinicListInfo.current  && !selectedClinic.current && (selectedClinic.current = clinicListInfo.current);
    const [current, setCurrent] = useState({searchTerm:'',activeRoles:[],clinic:null,lp:null,pages:[],savePref:true,clinics:[],pagination:{},roles:[]});
	const [state,setState] = useState({open:false});
    const handleClose = ()=> setState({open:false});
	const dataRef = useRef({})
	const cachedRoles = (dRoles,clinic=current.clinic,defaultRoles)=>{
		const roleCache = ROLE_CACHE;
		let roles = roleCache[clinic.clinic_id] || defaultRoles;
		defaultRoles && defaultRoles.length && (ROLE_CACHE[clinic.clinic_id] = roles);
		let activeRoles = [];
		if(roles?.length){
			dRoles = dRoles || dataRef.current.activeRoles;
			activeRoles = dRoles?.length > 0 ? roles.filter(r=>dRoles.includes(r.name)):null 
			activeRoles = activeRoles?.length?activeRoles : [roles[0]];
		}
		return {roleCache,roles,activeRoles};
	}
	const activePages = ({clinic,activeRoles})=>{
		const pageOpts = {clinicId:clinic.clinic_id,products:clinic.products};
		if(usePermissionByRole){
			pageOpts.permissions = (activeRoles || []).reduce((acc, role) => {
				acc[role.name] = role.permissions;
				return acc;
			}, {});
			pageOpts.roles = Object.keys(pageOpts.permissions);
		}
		return getActivePages(pageOpts);
	}
	const parseRoleMap = (rolemap)=>Object.keys(rolemap).filter(rn=>Array.isArray(rolemap[rn]) && rolemap[rn].length).map(rn=>({name:rn,permissions:rolemap[rn]}))
	const loadClinicRoles = async ()=>{
		if(!usePermissionByRole || !state.open || !current.clinic){
			return;
		}
		try{
			_app.events.trigger('cust:loader:show')
			let {roleCache,roles} = cachedRoles();
			if(!roles){
				const roleMap = await rolesApi(current.clinic.clinic_id);
				roles = parseRoleMap(roleMap);
			}
			if(!roles.length){
				roles = [{name:'Default',permissions:[]}];
			}
			roleCache[current.clinic.clinic_id] = roles;
			let activeRoles = dataRef.current.activeRoles?.length? roles.filter(r=>dataRef.current.activeRoles.includes(r.name)):null
		    activeRoles = activeRoles?.length?activeRoles : [roles[0]];
			const pages = activePages({clinic:current.clinic,activeRoles});
			setCurrent((pv)=>({...pv,activeRoles,roles,pages}));
		}catch (error) {
			toast({message:"We’re sorry. We are unable to process your request. Please try again later or reach out to the technical support"});
		}
		finally{
			_app.events.trigger('cust:loader:hide')
		}
	}
	const enterPressed = (e) => {
        if(e.key == 'Enter'){
            e.preventDefault();
            onSearch({doSeach:true});
        }
    }
	const onSearch=({searchTerm=current.searchTerm,doSeach})=>{
		const pv = {...current,searchTerm};
		let update = false;
		if(!searchTerm){
			pv.clinics = [...clinicListInfo.items];
			pv.pagination = paginationInfo(clinicListInfo);
			update = true;
		}
		else if(current.multiPage){
			update = current.searchTerm!=searchTerm;
			if(doSeach){
				loadClinics({page:1,search_term:searchTerm},true);
			}
		}
		else{
			const regex = new RegExp(searchTerm, "im")
			pv.clinics = clinicListInfo.items.filter(c=>regex.test(c.display_name));
			update = true;
		}
		update && setCurrent({...pv});
	}
	const loadClinics = async (filter={},loader=true)=>{
		const {page,page_size,order_by} = current.pagination;
		filter = {page,page_size,search_term:current.searchTerm,order_by,...filter};
		try {
			loader && _app.events.trigger('cust:loader:show')
			const {data} = await listApi(filter,{loader:false});
			const pagination = paginationInfo(data)
			setCurrent(pv=>({...pv,pagination,clinics:data.items}));
		} catch (error) {
			toast({message:"We’re sorry. We are unable to process your request. Please try again later or reach out to the technical support"});
		}
		finally{
			loader && _app.events.trigger('cust:loader:hide')
		}
		
        
	}
	const onChange = (value,field='clinic')=>{
		if(current[field] == value){
			return;
		}
		const pv = {...current,[field]:value};
		if(['clinic','activeRoles'].includes(field)){
			let pages = activePages(pv);
			if(field=='clinic' && usePermissionByRole){
				pv.activeRoles = [];
				pages = activePages({...pv,activeRoles:[{permissions:[],name:'default'}]});
			}
			pv.lp = pages[0]
			pv.pages = pages;
		}
		setCurrent({...pv,});
	}
	const onSortOrderChange=(order_by)=>loadClinics({order_by,page:1});
	const onPageChange=({page})=>loadClinics({page});
	const handleConfirm = ()=>{
		const clinicId = current.clinic?.clinic_id;
		if(clinicId){
			console.log('handleClinicChange-clinicId',current);
			const changed = selectedClinic.current?.clinic_id!=clinicId
			selectedClinic.current = current.clinic;
			const data = {
				clinicData:null,
				clinicId,
				lp:current.lp?.to,
				activeRoles:current.activeRoles,
				roles:current.roles,
				changed,
				useAttributes:changed?{userPreferences:{clinicSwitching:true}}:userPreferences.clinicSelectionPending?{userPreferences:{}}:null,
				savePref:current.savePref
			}
			if(!clinicListInfo.map[clinicId]){
				const cdata = clinicListInfo['ext_data'] || {index:clinicListInfo.items.length}
				cdata.id = clinicId;
				clinicListInfo.selectedClinicId = clinicId;
				clinicListInfo.items[cdata.index] = current.clinic;
				clinicListInfo['ext_data'] = cdata;
				data.clinicData = clinicListInfo;
			}
			onClinicSwitch(data);
			//savePref({lp:current.savePref?current.lp?.to:null})
		}
        handleClose();
    }
	const paginationInfo = ({page=1,page_size,items,total_items,order_by=SORT_OPTIONS[0].value})=>({page,page_size,total_items,order_by,multiple:items.length < total_items,pages:Math.ceil(total_items/page_size)})
    const openModal = (e,stProps)=>{
        e?.preventDefault();
		ROLE_CACHE={};
		const {roles,activeRoles} = cachedRoles(currentRole,selectedClinic.current,parseRoleMap(rolesPermissions));
		const pages = activePages({clinic:selectedClinic.current,activeRoles});
		const lp = (savedPref.lp?pages.find(p=>p.to == savedPref.lp):null) || pages[0]
		const pagination = paginationInfo(clinicListInfo)
        setCurrent({roles:roles || [],activeRoles,searchTerm:'',multiPage:clinicListInfo.total_items>clinicListInfo.items.length,pagination,clinic:selectedClinic.current,clinics:clinicListInfo.items,lp,savePref:true,pages});
        setState({open:true,...stProps});
		dataRef.current = {activeRoles:currentRole};
    }
	const isChanged = ()=>current.lp && current.clinic && (!usePermissionByRole || current.activeRoles?.length);//state.clinicSelectionPending || (current.lp && current.clinic && selectedClinic.current.clinic_id!=current.clinic.clinic_id)
    useEffect(()=>{
		loadClinicRoles()
	},[current.clinic])
    const cwidth = (usePermissionByRole?24:39)*10;
	return <>
	{(clinicListInfo.total_items>1 || showClinicName) && <Box sx={{fontSize:15,fontWeight:700,color:'#fff',display:'flex',cursor:'pointer',padding:1.5,backgroundColor:'var(--clinic_bg)'}} onClick={clinicListInfo.total_items>1?openModal:null}>{selectedClinic.current?.display_name} <Box sx={{fontSize:14,fontWeight:500,ml:0.6,color:'#fff',display:'flex',alignItems:'center'}} >{clinicListInfo.total_items>1 && <EditIcon sx={{fontSize:16}}/>}</Box></Box>} 
	{state.open &&<Modal open={state.open} sx={SX.confirmModal}>
        <Card sx={SX.card(theme)} >
			<Box sx={SX.container}>
				<CardHeader title={<>
					    {/* <img src={logo} alt="iNaira Healthcare" /> */}
						<h2>You're associated with multiple clinics—please choose one to proceed.</h2>
						<Box className="top-butons" sx={SX.modalActions(theme)}>
							{!state.clinicSelectionPending && <Button className="button secondary" variant="text" color="secondary" onClick={handleClose}>Cancel</Button> }
							<Button className="button primary" color="primary" disabled={!isChanged()} onClick={handleConfirm}>Continue</Button>
						</Box>
					</>} />
				<Divider sx={{width:'100%'}}/>
				<CardContent >
					<Box className={`clinic-list-ctr multi-page-${current.multiPage}`}>
						<Box className="search-header">
							<FormControl className="searchCtr" variant="outlined">
								<OutlinedInput
									//fullWidth
									value={current.searchTerm}
									placeholder={"Clinic Name"}
									onChange={(e) => onSearch({searchTerm:e.target.value})}
									onKeyDown={enterPressed}
									/* startAdornment={
										<InputAdornment position="start" 
										disablePointerEvents={!current.searchTerm.replace(/\s/g, '').length}
										>
										<SearchRoundedIcon
											aria-label="toggle password visibility"
											value={current.searchTerm}
											//onClick={()=>updateFilterAndSearch()}
											edge="start"
										/>
									</InputAdornment>
									} */
									endAdornment={<>{/* current.searchTerm && <InputAdornment position="start" 
										>
										<CloseIcon   className="delete" 
										onClick={()=>onSearch('')} 
	
										/>
									</InputAdornment> */}
									<InputAdornment position="end" 
										disablePointerEvents={!current.searchTerm.replace(/\s/g, '').length}
										>
										<Box sx={{ display: "flex", alignItems: "center" }}>
											{current.searchTerm && <><IconButton aria-label="clear" edge="end" onClick={()=>onSearch({searchTerm:''})}>
												<CloseIcon className="delete"/>
											</IconButton>
											<span className='separator'/></>}
											<IconButton aria-label="search" edge="end" onClick={()=>current.searchTerm.replace(/\s/g, '').length && onSearch({doSeach:true})}>
												<SearchRoundedIcon />
											</IconButton>
											</Box>
									</InputAdornment>
									</>}
								/>
							</FormControl>
							<Box className="page-info">
							<TextField
								select
								value={current.pagination?.order_by || SORT_OPTIONS[0].value}
								className="dropDown sort-menu"
								variant="outlined"
								slotProps={{
									inputLabel:{ shrink: true },
									select: {
										MenuProps:{
											sx:{zIndex:1405}	
										}
									}
								}}
								onChange={(e) => onSortOrderChange(e.target.value)}
							>
								{SORT_OPTIONS.map((sortOption) => (
									<MenuItem key={sortOption.value} value={sortOption.value}>
										{sortOption.label}
									</MenuItem>
								))}
							</TextField>
							</Box>
						</Box>
						<Box className={`clinic-list multi-page-${current.multiPage}`}>
						{current.clinics.map(clinic=><Box onClick={(e)=>onChange(clinic)} className={`clinic-item ${current.clinic.clinic_id == clinic.clinic_id && 'selected'}`}>
							{/* <Box className="logo"><img src={clinic.logo || logo} alt={clinic.display_name} /></Box> */}
							<Box className="name">{clinic.display_name}</Box>
						</Box>)}
						</Box>
						{current.clinics.length == 0 && <Box sx={{p:2}}>No clinics found</Box>}
						{current.pagination.multiple && <StyledPagination
							limit={current.pagination.page_size}
							offset={(current.pagination.page-1)*current.pagination.page_size}
							total_count={current.pagination.total_items}
							handleChange={(p) => onPageChange(p)}
							//handleChangeLimit={onPageLimitChange}
							//pageSizes={[5, INITIAL_PAGE_SIZE, 50, 100]}
						/>}
					</Box>
					<Divider sx={{width:'100%'}}/>
					<Box sx={{width:usePermissionByRole?1000:800,margin:'auto'}}>
						<Box sx={{display:'flex',justifyContent:'space-between',pt:1}}>
							<Box sx={{display:'flex',flexDirection:'column',width:`${cwidth}px`,alignItems:'flex-start'}}>
								<Box sx={{fontWeight:700,mb:1}}>Clinic</Box>
								<Box sx={{width:`calc(100% - ${((usePermissionByRole && current.pagination.multiple)?4:28)}px)`,borderRadius:1,textAlign:'left',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',border:'1px solid rgba(0, 0, 0, 0.23)',padding:'11px'}}> {current.clinic?.display_name} </Box>
							</Box>
							
							{usePermissionByRole && <Box sx={{display:'flex',flexDirection:'column',width:`500px`,alignItems:'flex-start'}}>
								<Box sx={{fontWeight:700,mb:1}}>Role</Box>
								<Autocomplete
									options={current.roles}
									multiple
									limitTags={3}
									getOptionLabel={option=>option.name}
									value={current.activeRoles}
									renderOption={(props,option,{selected}) => {
										const { key, ...optionProps } = props;
										return <Box component="li" key={option?.value || option} {...optionProps} sx={{ fontSize: 15 }}>
													<Checkbox
														icon={uncheckedIcon}
														checkedIcon={checkedIcon}
														style={{ marginRight: 8 }}
														checked={selected}
													/>
													{option?.name || option}
												</Box>
												}
									}
									isOptionEqualToValue={(option,v)=>(option.name) == (v?.name || v)}
									renderInput={(params) => (
										<TextField
											variant="outlined"
											{...params}
										/>
									)}

									renderValue={(value, getTagProps) =>
										value.map((option, index) => (
											<Chip {...getTagProps({ index })} key={option.name || option} label={option.name|| option} title={option.name|| option} />
										))

									}
									slotProps={{
										popper:{
											sx:{zIndex:1405}
										}
									}}
									onChange={(event, newValue) => onChange(newValue,"activeRoles")}
									fullWidth
								/>
							</Box> }
							<Box sx={{display:'flex',flexDirection:'column',width:`${cwidth}px`,alignItems:'flex-start'}}>
								<Box sx={{fontWeight:700,mb:1}}>Landing Page</Box>
								<Autocomplete
									options={current.pages}
									getOptionLabel={option=>option.label}
									disabled={!current.clinic}
									value={current.lp}
									renderOption={(props,option,{selected}) => {
										const { key, ...optionProps } = props;
										return <Box key={option?.to || option} {...optionProps} component="li" sx={menuItemSx} title={option.label}>
													
												<Box sx={{width:'100%',display:'flex',alignItems:'center'}}>{option?.label}</Box>
												</Box>
												}
									}
									isOptionEqualToValue={(option,v)=>(option.to) == (v?.to || v)}
									renderInput={(params) => (
										<TextField
											variant="outlined"
											{...params}
										/>
									)}
									slotProps={{
										popper:{
											sx:{zIndex:1405}
										}
									}}
									onChange={(event, newValue) => onChange(newValue,'lp')}
									fullWidth
								/>
							</Box>
						</Box>
						<Box className="d-flex">
							<Switch 
								label="Save Preferrence"
								checked={current.savePref}
								disabled={!current.clinic}
								onChange={(e)=>onChange(e.target.checked,'savePref')}
							/> 
						</Box>
					</Box>
				 <Loader />	
				</CardContent>
				<Box sx={SX.modalActions(theme)}>
					{!state.clinicSelectionPending && <Button className="button secondary" variant="text" color="secondary" onClick={handleClose}>Cancel</Button> }
					<Button className="button primary" color="primary" disabled={!isChanged()} onClick={handleConfirm}>Continue</Button>
				</Box>
			</Box>
        </Card>
    </Modal>}</>;
};

export default ClinicSelector;
